import { CheckOutlined, ContentCopy } from '@mui/icons-material';
import {
	IconButton,
	InputAdornment,
	TextField,
	TextFieldProps
} from '@mui/material';
import React, { useCallback } from 'react';
import { useCopyToClipboard } from 'usehooks-ts';

interface ICopyableTextFieldProps extends Omit<TextFieldProps, 'value'> {
	value: string | null;
	hideCopyButton?: boolean;
}

const CopyableTextField: React.FC<ICopyableTextFieldProps> = ({
	value,
	hideCopyButton = false,
	slotProps,
	...textFieldProps
}) => {
	const [copiedText, copy] = useCopyToClipboard();

	const copyValueToClipboard = useCallback(async () => {
		await copy(value || '');
	}, [copy, value]);

	return (
		<TextField
			{...textFieldProps}
			value={value || ''}
			slotProps={{
				...slotProps,
				inputLabel: { shrink: true, ...slotProps?.inputLabel },
				input: {
					readOnly: true,
					...slotProps?.input,
					endAdornment:
						!hideCopyButton && value ? (
							<InputAdornment position="end">
								<IconButton
									data-testid="field-copy-button"
									size="small"
									onClick={copyValueToClipboard}
								>
									{copiedText === value ? (
										<CheckOutlined
											fontSize="small"
											data-testid="copy-success-icon"
										/>
									) : (
										<ContentCopy fontSize="small" />
									)}
								</IconButton>
							</InputAdornment>
						) : undefined
				}
			}}
		/>
	);
};

export default CopyableTextField;
